export default "__VITE_ASSET__vh$04btf__"